import useUnstakeLiquidity from '@/application/write/migrate/useUnstakeLiquidity';
import { ActionItem, ActionList } from '../../modules/ActionList';
import { V2Position } from '@/core/migrate';
import { TransactionState } from '@nftx/react';
import { useState } from 'react';

const MigrateXSlp = ({
  v3VaultId,
  position,
  unstakeError,
  unstakeLiquidity,
  unstakeStatus,
  onCancel,
  onComplete,
}: {
  v3VaultId: string;
  position: V2Position;
  unstakeLiquidity: ReturnType<typeof useUnstakeLiquidity>[0];
  unstakeStatus: TransactionState;
  unstakeError: any;
  onComplete: () => void;
  onCancel: () => void;
}) => {
  const [status, setStatus] = useState<TransactionState>('None');

  return (
    <div>
      <ActionList
        title="Migrate Liquidity"
        description=""
        onComplete={() => undefined}
        onCancel={onCancel}
      >
        <ActionItem
          label="Unstake Liquidity"
          index={0}
          status={unstakeStatus}
          error={unstakeError}
          action={() => {
            setTimeout(() => {
              unstakeLiquidity({
                position,
                v3VaultId,
              });
            }, 2000);
          }}
        />
        <ActionItem
          label="Transfer SLP"
          index={1}
          status={status}
          error={null}
          action={() => {
            setStatus('Mining');
            setTimeout(() => {
              onComplete();
            }, 10000);
          }}
        />
        <ActionItem
          index={2}
          label="Approve Unstake"
          status="None"
          error={null}
          action={() => undefined}
        />
        <ActionItem
          index={3}
          label="Migrate Liquidity"
          status="None"
          error={null}
          action={() => undefined}
        />
      </ActionList>
    </div>
  );
};

export default MigrateXSlp;
